import React from "react";

const DragDrop = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="56"
      fill="none"
      viewBox="0 0 54 36"
    >
      <path
        fill="#ffffff"
        d="M41.122 10.127c-.74 0-1.466.067-2.172.182C37.189 4.55 31.732.355 25.27.355c-7.892 0-14.286 6.251-14.286 13.96 0 .688.054 1.365.153 2.03a9.582 9.582 0 00-1.151-.072c-5.365 0-9.713 4.248-9.713 9.492 0 5.244 4.348 9.497 9.713 9.497h11.768v-10.74h-6.712l12.083-13.426 12.083 13.426h-6.713v10.74h8.627c7.097 0 12.854-5.628 12.854-12.566 0-6.944-5.757-12.57-12.854-12.57z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_471_153"
          x1="27.125"
          x2="27.125"
          y1="0.355"
          y2="35.262"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="0" stopColor="#00BFA5"></stop>
          <stop offset="0" stopColor="#38E2CB"></stop>
          <stop offset="1" stopColor="#13E6C9"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default DragDrop;
